import { MapPin, Phone, Mail, Clock } from "lucide-react";

const Contact = () => {
  const contactInfo = [
    {
      icon: MapPin,
      title: "Adresse",
      content: "6 avenue des Verriers\n02600 Villers-Cotterêts"
    },
    {
      icon: Phone,
      title: "Téléphone",
      content: "06 46 63 49 68",
      link: "tel:0646634968"
    },
    {
      icon: Mail,
      title: "Email",
      content: "acicar60@gmail.com",
      link: "mailto:acicar60@gmail.com"
    },
    {
      icon: Clock,
      title: "Horaires",
      content: "Lun - Ven: 8h30 - 18h30\nSamedi: Sur rendez-vous\nDimanche: Fermé"
    }
  ];

  return (
    <div data-testid="contact-page">
      {/* Hero */}
      <section className="py-20 bg-gray-50">
        <div className="page-container">
          <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            CONTACTEZ-<span className="text-yellow-500">NOUS</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl">
            Une question ? Un projet ? N'hésitez pas à nous contacter, 
            notre équipe vous répondra dans les plus brefs délais.
          </p>
        </div>
      </section>

      {/* Contact Section - Centered */}
      <section className="section-spacing bg-white">
        <div className="page-container">
          <div className="max-w-3xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {contactInfo.map((item, index) => (
                <div 
                  key={index}
                  className="flex gap-4 p-6 bg-gray-50 border border-gray-200 rounded-xl"
                >
                  <div className="w-12 h-12 rounded-xl bg-yellow-100 flex items-center justify-center flex-shrink-0">
                    <item.icon className="w-6 h-6 text-yellow-600" />
                  </div>
                  <div>
                    <h3 className="text-gray-900 font-semibold mb-1">{item.title}</h3>
                    {item.link ? (
                      <a 
                        href={item.link}
                        className="text-gray-600 hover:text-yellow-600 transition-colors whitespace-pre-line"
                      >
                        {item.content}
                      </a>
                    ) : (
                      <p className="text-gray-600 whitespace-pre-line">{item.content}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Call to Action */}
            <div className="mt-12 text-center">
              <a 
                href="tel:0646634968"
                className="inline-flex items-center gap-3 bg-yellow-500 text-white px-8 py-4 rounded-xl font-bold text-lg hover:bg-yellow-600 transition-colors"
              >
                <Phone className="w-6 h-6" />
                Appelez-nous : 06 46 63 49 68
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="pb-16 bg-white">
        <div className="page-container">
          <div className="bg-gray-100 border border-gray-200 rounded-xl overflow-hidden h-[400px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2595.5!2d3.0833!3d49.2527!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e8a8c5c0b5b5b5%3A0x0!2s6%20Avenue%20des%20Verriers%2C%2002600%20Villers-Cotter%C3%AAts!5e0!3m2!1sfr!2sfr!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="ACICAR Location"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
